import { Box } from "@mui/material";
import { Question, QuestionOption } from "../exam/type";
import AnswerItem from "./AnwerItem";

interface AnswerItemProps {
  options: QuestionOption[];
  showAnswers?: boolean;
  question: Question;
}

export default function AnswerItems(props: AnswerItemProps) {
  const { options, showAnswers, question } = props;

  return (
    <Box sx={{ mt: 2 }}>
      {options.map((option) => (
        <AnswerItem
          key={option.option}
          option={option}
          question={question}
          showAnswers={showAnswers}
        />
      ))}
    </Box>
  );
}
